import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Loading } from 'e4shared';
import BlobImage from 'components/blobImage';
import { e4Format, isPast, isToday } from 'helpers/dates';

export const StaffReviewsModal = ({ data, st }) => {
    if (!data) return <Loading />;
    return (
        <div>
            {data.map(d => {
                return (
                    <div key={d.profile_Id} className="flex flex-top mb10">
                        <BlobImage height="30" className="img-circle mr10" folder="avatar" src={d.avatar} />
                        <div className="flex-grow">
                            <div>
                                <span className="mr10">
                                    <Link to={`/develop/reviews/${d.profile_Id}`}>{d.full_Name}</Link>
                                </span>
                                <span className="mr10">
                                    {st('Due')}: {e4Format(d.scheduled)}
                                </span>
                            </div>
                            {(isPast(d.scheduled) || !d.completed) && (
                                <div>
                                    {isPast(d.scheduled) && !isToday(d.scheduled) && (
                                        <span className="mr10">
                                            <label className="label label-danger uppercase">{st('Overdue')}</label>
                                        </span>
                                    )}
                                    {!d.completed && (
                                        <span className="mr10">
                                            <label className="label label-warning uppercase">{st('Incomplete')}</label>
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default withRouter(StaffReviewsModal);
